/**
 * English message catalogue — the source of truth.
 *
 * Every other catalogue is typed against this one, so a key added here and
 * forgotten elsewhere is a compile error rather than a blank button found in
 * production. Keys read as `area.thing`, and the value is the English text.
 */
export const en = {
  /* Navigation and shell */
  'nav.home': 'Home',
  'nav.discover': 'Discover people',
  'nav.friends': 'Friends',
  'nav.groups': 'Groups',
  'nav.messages': 'Messages',
  'nav.notifications': 'Notifications',
  'nav.settings': 'Settings',
  'nav.moderation': 'Moderation',
  'nav.profile': 'Profile',
  'nav.signOut': 'Sign out',
  'nav.settingsPrivacy': 'Settings & privacy',
  'nav.search': 'Search TalkVibe',
  'nav.skipToContent': 'Skip to content',
  'nav.yourInterests': 'Your interests',
  'nav.contacts': 'Contacts',
  'nav.connectionRequests': 'Connection requests',
  'nav.wantsToConnect': 'wants to connect',
  'nav.noContacts': 'No contacts yet.',
  'nav.findPeople': 'Find people',
  'nav.tagline': 'TalkVibe · Connect with people worldwide. Chat in your own language.',
  'nav.myProfile': 'My profile',
  'nav.followersLabel': 'Followers',
  'nav.followingLabel': 'Following',
  'nav.quickNav': 'Go to',
  'nav.myGroups': 'My groups',
  'nav.newsFeed': 'News feed',
  'nav.manage': 'Manage',
  'nav.verifyEmail': 'Confirm your email address to secure your account.',
  'nav.verifySend': 'Send link',
  'nav.dismiss': 'Dismiss',
  'nav.accountMenu': 'Account menu',
  'nav.noGroups': 'No groups yet',
  'nav.members.one': '{count} member',
  'nav.members.other': '{count} members',
  'nav.whoToMeet': 'People you may want to meet',
  'nav.suggested': 'Suggested for you',
  'common.soon': 'Soon',
  'common.notReadyYet': 'Not built yet — the layout is ready for it.',
  'nav.marketplace': 'Marketplace',
  'market.title': 'Marketplace',
  'market.breadcrumbHome': 'Home',
  'market.heading': 'Things for sale near you',
  'market.sell': 'List something for sale',
  'market.searchPlaceholder': 'Search the marketplace…',
  'market.areaLabel': 'Search area',
  'market.changeArea': 'Change',
  'market.radius': 'Within',
  'market.categories': 'Categories',
  'market.categoryAll': 'Everything',
  'market.categoryTech': 'Tech and gadgets',
  'market.categoryComputers': 'Computers and desks',
  'market.categoryFashion': 'Clothing and fashion',
  'market.categoryHome': 'Furniture and home',
  'market.categoryVehicles': 'Vehicles and parts',
  'market.categoryBooks': 'Books and courses',
  'market.priceRange': 'Price range',
  'market.priceMin': 'Lowest',
  'market.priceMax': 'Highest',
  'market.priceApply': 'Apply price filter',
  'market.priceFree': 'Free',
  'market.condition': 'Condition',
  'market.conditionNew': 'New, sealed or unopened',
  'market.conditionLikeNew': 'Barely used',
  'market.conditionUsed': 'Used, working normally',
  'market.sellerType': 'Seller',
  'market.sellerVerified': 'Identity-checked sellers',
  'market.sellerOfficial': 'Official shops',
  'market.sortBy': 'Sort by',
  'market.sortRecent': 'Most recent',
  'market.sortPriceAsc': 'Price: low to high',
  'market.sortPriceDesc': 'Price: high to low',
  'market.sortNearest': 'Nearest first',
  'market.viewGrid': 'Grid view',
  'market.viewList': 'List view',
  'market.found': '{count} listings',
  'market.loadMore': 'Show more',
  'market.showing': 'Showing {shown} of {total}',
  'market.mapTitle': 'Browse by pickup point',
  'market.mapExpand': 'Open full map',
  'market.safety': 'Trading safely',
  'market.safetyBody': 'Check who you are dealing with, meet somewhere public, and look at the item before any money changes hands.',
  'market.emptyTitle': 'Nothing is for sale yet',
  'market.emptyBody': 'Nobody has listed anything here. If you have something to sell, you can be the first.',
  'market.save': 'Save this listing',
  'market.categorySports': 'Sport and outdoors',
  'market.categoryMusic': 'Instruments and audio',
  'market.categoryToys': 'Toys and games',
  'market.categoryOther': 'Everything else',
  'market.sold': 'Sold',
  'market.sellerGone': 'Seller has left',
  'market.unsave': 'Remove from saved',
  'market.foundMore': '{count} listings so far',
  'market.failedTitle': 'The marketplace could not be loaded',
  'market.failedBody': 'Something went wrong on the way to the listings. Try again in a moment.',
  'market.noMatchTitle': 'Nothing matches that',
  'market.noMatchBody': 'No listing matches the search, category, price or condition you picked. Widen one of them and have another look.',
  'market.backToMarket': 'Back to the marketplace',
  'market.sellTitle': 'List something for sale',
  'market.formTitleLabel': 'What are you selling?',
  'market.formTitlePlaceholder': 'Mechanical keyboard, barely used',
  'market.formDescription': 'Description',
  'market.formDescriptionPlaceholder': 'Say what it is, how old it is, and anything a buyer would want to know before they come to see it.',
  'market.formCategory': 'Category',
  'market.formCondition': 'Condition',
  'market.formPriceHeading': 'Price',
  'market.formFree': 'Give it away free',
  'market.formPrice': 'Asking price',
  'market.formPricePlaceholder': '1800',
  'market.formWasPrice': 'Reduced from',
  'market.formWasPricePlaceholder': 'Leave blank if it is not reduced',
  'market.formPhotoHeading': 'Photo',
  'market.formPhotoRemove': 'Remove the photo',
  'market.photoCover': 'Cover',
  'market.photoMakeCover': 'Make cover',
  'market.photoRemoveOne': 'Remove photo {n}',
  'market.photoShow': 'Show photo {n}',
  'market.photoLimit': 'A listing can have {count} photos.',
  'market.photosFailed': 'The listing was created, but some photos did not upload ({which}). Open it and add them again.',
  'market.formPhotoHint': 'Up to {count} photos. The first one is the cover buyers see in the grid. They upload once the listing is created.',
  'market.formArea': 'Where can it be collected?',
  'market.formAreaPlaceholder': 'Near BTS Asok',
  'market.formAreaHint': 'Write it however you would tell a friend. There is no map behind this, so a district or a station is more use than an address.',
  'market.sellNotice': 'TalkVibe does not handle the money and does not check anybody’s identity. Your listing is an advert; everything after that is between you and the buyer.',
  'market.formPublish': 'Publish the listing',
  'market.formPublishing': 'Publishing…',
  'market.photoFailed': 'The listing was created, but the photo did not upload. Open it and try the photo again.',
  'market.previewHeading': 'How it will look',
  'market.previewTitleEmpty': 'Your listing',
  'market.goneTitle': 'This listing was taken down',
  'market.goneBody': 'The seller removed it. It was here, so the link is not broken — there is just nothing to buy.',
  'market.missingTitle': 'No such listing',
  'market.missingBody': 'That link does not point at anything. Check it, or look through the marketplace instead.',
  'market.noDescription': 'The seller did not write a description.',
  'market.sellerHeading': 'Seller',
  'market.viewSellerProfile': 'Open the seller’s profile',
  'market.viewItem': 'View item',
  'market.yourChats': 'Your marketplace chats',
  'market.listingGone': 'A listing that has gone',
  'market.messageSeller': 'Message seller',
  'market.notForSale': 'No longer for sale',
  'market.messageSellerFailed': 'That chat could not be opened.',
  'market.contactBody': 'This chat is about this item only, and it is kept out of your Messages. Nothing here is paid for through TalkVibe — agree how to pay and meet between yourselves.',
  'market.manageHeading': 'Your listing',
  'market.markSold': 'Mark it sold',
  'market.markAvailable': 'Put it back up for sale',
  'market.removeListing': 'Take it down',
  'market.removeConfirm': 'Take this listing down? It will disappear from the marketplace and cannot be put back.',
  'nav.pages': 'Pages',
  'nav.games': 'Games',
  'nav.bookmarks': 'Bookmarks',
  'bookmarks.lede': 'Posts you saved. Only you can see this list.',
  'bookmarks.emptyTitle': 'Nothing saved yet',
  'bookmarks.emptyBody': 'Save a post from the ⋯ menu on it and it will be here.',
  'nav.events': 'Events',
  'nav.media': 'Media',
  'nav.favouriteGroups': 'Favourite groups',
  'home.filterForYou': 'For you',
  'home.filterPopular': 'Popular',
  'home.tuneFeed': 'Feed settings',
  'composer.photo': 'Photo',
  'composer.removePhoto': 'Remove this photo',
  'composer.clearFeeling': 'Clear the feeling',
  'composer.untag': 'Untag {name}',
  'composer.pollOption': 'Option {n}',
  'composer.attachmentsDropped': 'Your post went out, but TalkVibe did not save: {what}. Try adding it again in a moment.',
  'composer.addOption': 'Add an option',
  'composer.removeOption': 'Remove this option',
  'composer.removePoll': 'Remove the poll',
  'composer.pollMultiple': 'Allow more than one answer',
  'composer.pollCloses': 'Closes',
  'composer.pollNeverCloses': 'Never',
  'composer.pollDays.one': '{count} day',
  'composer.pollDays.other': '{count} days',
  'composer.tagFriendsOnly': 'Only people you are connected to can be tagged.',
  'post.isFeeling': 'is feeling {feeling}',
  'post.with': 'with',
  'post.onProfileOf': "on {name}'s profile",
  'post.votes.one': '{count} vote',
  'post.votes.other': '{count} votes',
  'post.openPhoto': 'Open photo {n} of {total}',
  'post.photoViewer': 'Photos on this post',
  'post.previousPhoto': 'Previous photo',
  'post.nextPhoto': 'Next photo',
  'post.photoCounter': '{n} of {total}',
  'post.sharePost': 'Share the post',
  'post.reportPost': 'Report this post',
  'post.photoComments': 'Comments on this photo',
  'post.pollClosed': 'Voting has closed',
  'post.pollMultiple': 'More than one answer allowed',
  'feeling.happy': 'happy',
  'feeling.grateful': 'grateful',
  'feeling.excited': 'excited',
  'feeling.relaxed': 'relaxed',
  'feeling.loved': 'loved',
  'feeling.proud': 'proud',
  'feeling.tired': 'tired',
  'feeling.sad': 'sad',
  'feeling.thoughtful': 'thoughtful',
  'feeling.motivated': 'motivated',
  'notifications.postMention': '{name} tagged you in a post',
  'composer.photoCount': '{n} of {max} photos',
  'composer.poll': 'Poll',
  'composer.feeling': 'Feeling',
  'composer.tagFriends': 'Tag friends',
  'trending.title': 'Trending',
  'trending.window': 'Busiest right now, over the last {days} days',
  'trending.posts': '{count} posts',
  'tag.publicOnly': 'Posts anybody can read. Ones in private groups, on hidden profiles or on unlisted pages are never listed here.',
  'tag.count': '{count} posts on this page',
  'tag.more': 'Show more',
  'tag.emptyTitle': 'Nobody has used this tag',
  'tag.emptyBody': 'No public post carries it yet. Write one with the tag in it and this is where it lands.',
  'tag.failedTitle': 'This topic could not be loaded',
  'tag.failedBody': 'Something went wrong on the way to the posts. Try again in a moment.',
  'trending.settings': 'Trending settings',
  'trending.empty': 'No hashtags yet.',
  'trending.emptyBody': 'Nothing has carried a hashtag in the last {days} days. Add one to a post and it appears here.',
  'post.verified': 'Verified account',
  'post.repost': 'Repost',
  'post.views': 'Views',
  'post.bookmark': 'Save',
  'post.moreActions': 'More actions',
  'post.unrepost': 'Undo repost',
  'post.repostGone': 'This post is no longer available.',
  'post.unbookmark': 'Remove from saved',
  'nav.refresh': 'Refresh',
  'nav.seeMore': 'See more',
  'home.feedFilter': 'Feed',
  'home.filterFollowing': 'Following',
  'home.filterExplained': 'Your feed is everyone you follow, newest first. Nothing is reordered.',

  /* Authentication */
  'auth.signIn': 'Sign in',
  'auth.signUp': 'Create account',
  'auth.email': 'Email',
  'auth.emailOrUsername': 'Email or username',
  'auth.username': 'Username',
  'auth.password': 'Password',
  'auth.currentPassword': 'Current password',
  'auth.newPassword': 'New password',
  'auth.forgotPassword': 'Forgot your password?',
  'auth.resetPassword': 'Reset password',
  'auth.sendResetLink': 'Send reset link',
  'auth.backToSignIn': 'Back to sign in',
  'auth.noAccount': 'No account yet?',
  'auth.haveAccount': 'Already have an account?',
  'auth.country': 'Country',
  'auth.language': 'Language you read in',
  'auth.languageHelp': 'Messages are translated into this language, and the app is shown in it.',
  'auth.displayName': 'Display name',
  'auth.signingIn': 'Signing in…',
  'auth.creating': 'Creating your account…',
  'auth.welcomeBack': 'Welcome back. Sign in to carry on.',
  'auth.identifierPlaceholder': 'name@example.com or @username',
  'auth.passwordPlaceholder': 'Your password',
  'auth.showPassword': 'Show password',
  'auth.hidePassword': 'Hide password',
  'auth.secureNote': 'Encrypted connection. Your password is never stored in a readable form.',
  'auth.resetDone': 'Your password has been changed. Sign in with the new one.',
  'auth.signInFailed': 'Could not sign in. Please try again.',
  'auth.orWithEmail': 'or sign in with your email',
  'auth.loginLede': 'Everyone writes in the language they think in — and reads in theirs.',

  /* Chat */
  'chat.send': 'Send',
  'chat.typeMessage': 'Write a message',
  'chat.placeholder': 'Write a message…',
  'chat.messageLabel': 'Message',
  'chat.addPhoto': 'Send a photo',
  'chat.voiceNote': 'Voice note',
  'chat.recordVoice': 'Record a voice message',
  'chat.stopRecording': 'Stop recording',
  'chat.discardRecording': 'Discard recording',
  'chat.micBlocked': 'TalkVibe cannot use your microphone. Allow it in your browser settings, then tap again.',
  'chat.micMissing': 'No microphone was found.',
  'chat.micUnsupported': 'This browser cannot record audio.',
  'chat.micBusy': 'Something else is using the microphone. Close it and try again.',
  'chat.micFailed': 'The microphone could not be opened ({reason}).',
  'chat.playVoice': 'Play voice message',
  'chat.pauseVoice': 'Pause',
  'chat.voicePreparing': 'Preparing…',
  'chat.voiceFailed': 'This recording could not be prepared.',
  'chat.sending': 'Sending…',
  'chat.readBy': 'Read by {count}',
  'chat.readByTitle': '{count} people have read this',
  'chat.read': 'Read',
  'chat.removePhoto': 'Remove photo',
  'chat.emoji': 'Emoji',
  'chat.photo': 'Photo',
  'chat.formerMember': 'Former member',
  'chat.photoExpanded': 'Photo, expanded',
  'chat.openPhoto': 'Open photo',
  'chat.replyTo': 'Reply',
  'chat.replyingTo': 'Replying to',
  'chat.cancelReply': 'Cancel reply',
  'chat.replyGone': 'The message this answers was deleted',
  'chat.likeMessage': 'Like',
  'chat.deleteMessage': 'Delete message',

  'emoji.faces': 'Smileys',
  'emoji.feelings': 'Feelings',
  'emoji.gestures': 'Hands',
  'emoji.hearts': 'Hearts',
  'emoji.people': 'People',
  'emoji.nature': 'Nature',
  'emoji.food': 'Food',
  'emoji.objects': 'Things',
  'emoji.more': 'Your keyboard can type any other emoji straight into the field.',
  'chat.typing': 'typing…',
  'chat.online': 'Online',
  'chat.offline': 'Offline',
  'chat.back': 'Back to messages',
  'chat.noMessages': 'No messages yet',
  'chat.startConversation': 'Say hello to start the conversation.',
  'chat.conversationStart': 'This is the beginning of your conversation.',
  'chat.viewOriginal': 'View original',
  'chat.hideOriginal': 'Hide original',
  'chat.translatedFrom': 'Translated from {language}',
  'chat.messageDeleted': 'Message deleted',
  'chat.delete': 'Delete',
  'chat.retry': 'Retry',
  'chat.discard': 'Discard',
  'chat.failedToSend': 'Not sent',
  'chat.loadOlder': 'Load older messages',
  'chat.connecting': 'Connecting…',
  'chat.reconnecting': 'Reconnecting…',
  'chat.offlineNotice': 'You are offline. Messages will send when you reconnect.',

  /* Conversations */
  'conversations.title': 'Messages',
  'conversations.filterAll': 'All',
  'conversations.filterUnread': 'Unread',
  'conversations.filterGroups': 'Groups',
  'conversations.filterStarred': 'Starred',
  'conversations.newChat': 'New message',
  'conversations.searchPlaceholder': 'Search your chats',
  'conversations.pickOne': 'Pick a conversation',
  'conversations.pickOneHelp': 'Choose one on the left, or start a new one.',
  'conversations.friendsOnly': 'You can message anyone you are connected to.',
  'friends.blockConfirm': 'Block {name}? They will not be able to message you or find you.',
  'chat.call': 'Call',
  'chat.video': 'Video',
  'chat.searchInside': 'Search',
  'chat.details': 'Conversation details',
  'chat.mute': 'Mute',
  'chat.save': 'Save',
  'chat.sharedMedia': 'Shared photos and video',
  'chat.sharedFiles': 'Shared files',
  /* ---- Calling ---------------------------------------------------------- */
  /*
   * Audio calls. Written to be read in a panel the size of a playing card, so
   * every line is short — and every ending says *why*, because a call that just
   * disappears leaves somebody wondering whether they were hung up on.
   */
  /* ---- Games ------------------------------------------------------------ */
  /*
   * OX, played inside a conversation. Every ending says what happened: a board
   * that just stops leaves somebody counting squares to work out who won.
   */
  'game.title': 'Game',
  'game.choose': 'Play:',
  'game.kind.tictactoe': 'Noughts and crosses',
  'game.kind.connectfour': 'Connect Four',
  'game.kind.gomoku': 'Five in a row',
  'game.play': 'Play a game',
  'game.yourTurn': 'Your turn',
  'game.theirTurn': '{name} is thinking…',
  'game.youAre': 'You are {mark}',
  'game.youWon': 'You won',
  'game.theyWon': '{name} won',
  'game.draw': 'A draw',
  'game.youResigned': 'You resigned',
  'game.theyResigned': '{name} resigned',
  'game.resign': 'Resign',
  'game.rematch': 'Play again',
  /* The Games tab. */
  'game.waiting': 'Waiting for them',
  'game.finished': 'Finished',
  'game.listHelp': 'Games you are playing with the people you talk to.',
  'game.noneYet': 'No games yet',
  'game.noneYetHelp': 'Open a chat with a friend and tap the game button to start one.',
  'game.listFailed': 'Your games could not be loaded.',
  /* Said to a screen reader, which cannot see which square is which. */
  'game.emptySquare': 'Square {n}, empty',
  'game.takenSquare': 'Square {n}, {mark}',

  'calls.title': 'Call',
  'calls.ringing': 'Ringing…',
  'calls.incoming': 'Incoming call',
  'calls.connecting': 'Connecting…',
  'calls.accept': 'Answer',
  'calls.decline': 'Decline',
  'calls.hangUp': 'Hang up',
  'calls.mute': 'Mute microphone',
  'calls.unmute': 'Unmute microphone',
  'calls.mutedNotice': 'Your microphone is off',
  'calls.ended': 'Call ended',
  'calls.declined': 'Call declined',
  'calls.busy': 'They are on another call',
  'calls.unanswered': 'No answer',
  'calls.failed': 'The call could not connect',
  'calls.noMicrophone': 'TalkVibe needs access to your microphone',
  /*
   * Said only after a failure, and only when it is the likely cause: without a
   * relay server, two people on networks that will not connect directly - most
   * mobile networks - cannot reach each other at all.
   */
  'calls.noRelay': 'Calls between some networks need a relay server, which is not set up yet.',
  'conversations.none': 'No conversations yet',
  'conversations.noneHelp': 'Find someone to talk to and your conversations will appear here.',
  'conversations.noMessagesYet': 'No messages yet',
  'conversations.loading': 'Loading conversations…',
  'conversations.loadMore': 'Load more',

  /* Groups */
  'group.create': 'Create group',
  'group.privacyChatNote': 'Either way, the group chat is members-only. Public opens the posts, not the conversation.',
  'group.visibilityVisibleHelp': 'Anyone can find this group by searching TalkVibe.',
  'group.visibilityHiddenHelp': 'Only people you send the link to can find it.',
  'group.tags': 'Tags',
  'group.tagPlaceholder': 'design, study, bangkok…',
  'group.addTag': 'Add',
  'group.removeTag': 'Remove #{tag}',
  'group.coverChoose': 'Choose an image',
  'group.coverChange': 'Choose another',
  'group.coverHelp': 'Added once the group exists. You can change it any time.',
  'group.coverRemove': 'Remove the cover',
  'group.publicGroup': 'Public group',
  'group.privateGroup': 'Private group',
  'group.publicLong': 'Anyone signed in can read the posts. The chat stays members-only.',
  'group.newTitle': 'Create a group',
  'group.youAreOwner': 'You are creating this group as its owner',
  'group.owner': 'Owner and creator',
  'group.nameHelp': 'A name that says what the group is for. You can change it later.',
  'group.privacy': 'Privacy',
  'group.privacyPublic': 'Public',
  'group.privacyPublicHelp': 'Anyone could see the members and what they post.',
  'group.privacyPrivate': 'Private',
  'group.privacyPrivateHelp': 'Only members see the members and the posts.',
  'group.visibility': 'Who can find it',
  'group.visibilityVisible': 'Findable',
  'group.visibilityHidden': 'Hidden',
  'group.category': 'Category',
  'group.invite': 'Invite friends',
  'group.chosenCount': '{count} chosen',
  'group.removeInvite': 'Remove {name}',
  'group.inviteHelp': 'Only friends can be invited, and a group holds up to {max} people. Anyone you leave out can be added later.',
  'group.description': 'About this group',
  'group.descriptionPlaceholder': 'What the group is for, and how members are expected to treat each other.',
  'group.preview': 'Preview',
  'group.previewNameEmpty': 'Your group',
  'group.previewJoined': 'Joined',
  'group.previewInvite': 'Invite',
  'group.cover': 'Cover image',
  'group.tabAbout': 'About',
  'group.tabMembers': 'Members',
  'group.tabEvents': 'Events',
  'group.tabMedia': 'Media',
  'group.aboutTitle': 'About this group',
  'group.membersOnlyLong': 'Members only. Nobody outside the group can read what is posted here.',
  'group.createdBy': 'Created today by {name}',
  'group.guidelines': 'Group rules',
  'group.guidelinesHint': 'Respect every member, no spam',
  'group.rulesPlaceholder': 'One line per rule. Members see these on the group page.',
  'group.rulesHelp': 'Optional. Organisers can change them later.',
  'group.rulesNone': 'This group has not set any rules.',
  'group.rulesTitle': 'Group rules',
  'group.created': 'Created {date}',
  'group.noDescription': 'No description yet.',
  'group.mediaNone': 'No photos have been posted here yet.',
  'group.membersTitle': 'Members',
  'group.kind': 'What is this group for?',
  'group.kindChat': 'Talking',
  'group.kindChatHelp': 'A conversation. It appears in Messages and opens to the chat.',
  'group.kindPosts': 'Posting',
  'group.kindPostsHelp': 'A feed. It stays out of Messages and opens to the posts.',
  'group.kindNote': 'Both work either way — this decides where the group is listed and what it opens on, and an organiser can change it later.',
  'group.kindMakeChat': 'Make it a chat group',
  'group.kindMakePosts': 'Make it a post group',
  'group.kindSwitchWhy': 'Changes where the group is listed and what it opens on. Nothing is lost either way: the chat and the feed both keep working.',
  'group.editCover': 'Edit cover',
  'group.joined': 'Joined',
  'group.searchInside': 'Search in this group',
  'group.searchInsideWhy': 'Nothing searches inside a group yet. A box that filters the posts already on screen is not a search, so this waits for one that asks the server.',
  'group.andOthers': 'and {count} others are members',
  'group.tabHighlights': 'Highlights',
  'group.tabHighlightsWhy': 'Nothing marks a post as a highlight, and nothing ranks one above another.',
  'group.tabEventsWhy': 'An event needs a date, a guest list and a reminder. A third of that is worse than none.',
  'group.tabFiles': 'Files',
  'group.tabFilesWhy': 'Uploads here are images: the pipeline is Sharp, which does not handle a document.',
  'group.organisersTitle': 'Organisers',
  'group.seeAll': 'See all',
  'group.messageOrganiser': 'Open their profile',
  'group.messageOrganiserWhy': 'Messages are between friends, so this opens their profile where a friend request starts.',
  'group.createdTitle': 'Created',
  'group.rulesBy': 'by the organisers',
  'groups.title': 'Groups',
  'groups.lede': 'The groups you are in, and the ones you can find.',
  'groups.create': 'Create a group',
  'groups.discoverTitle': 'Find a group',
  'groups.searchPlaceholder': 'Search groups by name…',
  'groups.searchHint': 'Matches the start of a group’s name.',
  'groups.allCategories': 'All',
  'groups.posts': '{count} posts',
  'groups.join': 'Join',
  'groups.askToJoin': 'Ask to join',
  'groups.asked': 'Waiting',
  'groups.open': 'Open',
  'groups.more': 'Show more',
  'groups.yoursTitle': 'Your groups',
  'groups.yoursEmpty': 'You are not in any group yet. Find one below, or start your own.',
  'groups.noneTitle': 'No groups match that',
  'groups.noneBody': 'Nothing findable matches the name or category you picked. Groups set to hidden are reachable by invitation only and never appear here.',
  'groups.failedTitle': 'The group list could not be loaded',
  'groups.failedBody': 'Something went wrong on the way to the directory. Try again in a moment.',
  'groups.suggestedTitle': 'Groups you might like',
  'groups.suggestedWhy': 'Nothing recommends a group yet. The only signal here is the category you can already filter by, and calling a filter a suggestion would be a reason that is not real.',
  'group.joinPolicy': 'Getting in',
  'group.joinApproval': 'Approve each person',
  'group.joinApprovalHelp': 'An organiser decides on anybody who asks to join, and on anybody a member invites.',
  'group.joinOpen': 'Anybody can join',
  'group.joinOpenHelp': 'Somebody who can find the group joins straight away, and a member’s invite lands immediately.',
  'group.joinPolicyNote': 'Members can invite friends either way. This decides whether the invite lands or waits for an organiser.',
  'group.inviteOne': 'Invite',
  'group.invited': 'Invited',
  'group.inviteNobody': 'All of your friends are already here or already waiting.',
  'group.inviteOpenNote': 'Anybody you invite joins straight away.',
  'group.inviteApprovalNote': 'An organiser approves anybody you invite, unless you are one.',
  'group.invitedBy': 'invited by {name}',
  'group.askedToJoin': 'asked to join',
  'group.waitingTitle': 'Waiting to join',
  'group.approve': 'Approve',
  'group.decline': 'Decline',
  'group.roleOwner': 'Owner',
  'group.roleAdmin': 'Organiser',
  'group.roleMember': 'Member',
  'group.you': 'You',
  'group.name': 'Group name',
  'group.namePlaceholder': 'Weekend plans',
  'group.searchConnections': 'Search your connections',
  'group.needConnections': 'You need connections before you can start a group.',
  'group.noMatches': 'Nobody matches that.',
  'group.selectedCount': '{selected} selected · up to {max}',
  'group.creating': 'Creating…',
  'group.leave': 'Leave',
  'group.leaveConfirm': 'Leave “{name}”?',
  'group.members.one': '{count} member',
  'group.members.other': '{count} members',
  'group.someoneTyping': '{name} is typing…',
  'group.peopleTyping': '{count} people are typing…',

  'group.feed': 'Posts',
  'group.chat': 'Chat',
  'group.writePost': 'Share something with the group',
  'group.noPosts': 'Nothing posted yet',
  'group.noPostsHelp': 'Be the first to post here.',
  'group.membersOnly': 'Only members can see what is posted here.',

  /* Discover */
  'discover.title': 'Discover people',
  'discover.searchPlaceholder': 'Search by name or @username',
  'discover.filterCountry': 'Country',
  'discover.filterLanguage': 'Language',
  'discover.filterInterest': 'Interest',
  'discover.anyCountry': 'Any country',
  'discover.anyLanguage': 'Any language',
  'discover.anyInterest': 'Any interest',
  'discover.noResults': 'Nobody matched',
  'discover.noResultsHelp': 'Try a different country, language or interest.',
  'discover.loadMore': 'Load more',
  'discover.searching': 'Searching…',

  /* Friends and connections */
  'friends.title': 'Friends',
  'friends.lede': 'Your connections, the requests waiting on you, and people worth meeting.',
  'friends.onlineNow': '{count} online',
  'friends.tabAll': 'All friends',
  'friends.tabIncoming': 'Requests',
  'friends.tabOutgoing': 'Requests you sent',
  'friends.tabRecent': 'Recently added',
  'friends.tabClose': 'Close friends',
  'friends.tabBirthdays': 'Birthdays',
  'friends.searchPlaceholder': 'Search by name or handle…',
  'friends.filterCountry': 'Anywhere',
  'friends.filterSchool': 'School',
  'friends.filterWork': 'Workplace',
  'friends.sortBy': 'Sort',
  'friends.sortRecent': 'Recently added',
  'friends.sortName': 'By name',
  'friends.sortMutual': 'Most mutual friends',
  'friends.viewGrid': 'Grid',
  'friends.viewList': 'List',
  'friends.findNew': 'Find people',
  'friends.showing': 'Showing {shown} of {total}',
  'friends.noMatch': 'Nobody matches that',
  'friends.noMatchHelp': 'Try a different name, or clear the filters.',
  'friends.noIncoming': 'No requests waiting',
  'friends.noOutgoing': 'You have not sent any requests',
  'friends.suggestions': 'People you may know',
  'friends.seeAll': 'See all',
  'friends.closeFriend': 'Close friend',
  'friends.mute': 'Mute their posts',
  'friends.viewProfile': 'View profile',
  'friends.connected': 'Connected ({count})',
  'friends.requests': 'Requests ({count})',
  'friends.connect': 'Connect',
  'friends.requestSent': 'Request sent',
  'friends.accept': 'Accept',
  'friends.reject': 'Decline',
  'friends.cancel': 'Cancel request',
  'friends.remove': 'Remove connection',
  'friends.message': 'Message',
  'friends.follow': 'Follow',
  'friends.unfollow': 'Following',
  'friends.unfollowAction': 'Unfollow',
  'friends.following.busy': 'Following…',
  'friends.unfollowing.busy': 'Unfollowing…',
  'friends.block': 'Block',
  'friends.unblock': 'Unblock',
  'friends.report': 'Report',
  'friends.none': 'No connections yet',
  'friends.noneHelp': 'Find people who share your language or interests.',
  'friends.noRequests': 'No requests waiting',
  'friends.since': 'Connected {when}',

  /* Profile */
  'profile.editProfile': 'Edit profile',
  'profile.followers.one': '{count} follower',
  'profile.friendCount.one': '{count} friend',
  'profile.friendCount.other': '{count} friends',
  'profile.followers.other': '{count} followers',
  'profile.following': '{count} following',
  'profile.interests': 'Interests',
  'profile.speaks': 'Speaks',
  'profile.reads': 'Reads',
  'profile.birthday': 'Born {when}',
  'profile.joined': 'Joined {when}',
  'profile.notFound': 'Profile not found',
  'profile.notFoundHelp': 'This account does not exist, or you cannot see it.',
  'profile.loadFailed': 'This profile could not be loaded.',
  'profile.ownNotice': 'This is how other people see your profile.',
  'profile.sending': 'Sending…',
  'profile.requestSent': 'Request sent',
  'profile.accepting': 'Accepting…',
  'profile.acceptRequest': 'Accept request',
  'profile.opening': 'Opening…',
  'profile.friends': 'Friends',
  'profile.about': 'About',
  'profile.links': 'Links',
  'profile.intro': 'Intro',
  'profile.livesIn': 'Lives in {place}',
  'profile.readsIn': 'Reads in {language}',
  'profile.localTime': 'Local time {time}',
  'profile.followsYouShort': 'Follows you',
  'profile.tabPosts': 'Posts',
  'profile.tabAbout': 'About',
  'profile.tabFriends': 'Friends',
  'profile.tabPhotos': 'Photos and media',
  'profile.tabPages': 'Pages they follow',
  'profile.tabSpaces': 'Audio spaces',
  'profile.filterAll': 'All posts',
  'profile.filterPinned': 'Pinned',
  'profile.filterMedia': 'Media',
  'profile.work': 'Work',
  'profile.education': 'Education',
  'profile.followersTitle': 'Followers',
  'profile.historyTitle': 'Work and education',
  'profile.workTitle': 'Work',
  'profile.educationTitle': 'Education',
  'profile.present': 'now',
  'profile.friendsTitle': 'Friends',
  'profile.friendsEmpty': 'No friends to show yet.',
  'profile.photosEmpty': 'No photos posted yet.',
  'profile.pagesEmpty': 'Not following any pages yet.',
  'profile.followersEmpty': 'Nobody follows this account yet.',
  'profile.seeAll': 'See all',
  'profile.copyLink': 'Copy link to profile',
  'profile.linkCopied': 'Link copied',
  'profile.block': 'Block this person',
  'profile.unfriend': 'Remove friend',
  'profile.muteposts': 'Mute their posts',
  'profile.restrict': 'Limit what they see',
  'profile.audioCall': 'Voice call',
  'profile.moreOptions': 'More options',
  'profile.friendsSince': 'Friends',
  'profile.connectFailed': 'Could not send the request.',

  /* Notifications */
  'notifications.title': 'Notifications',
  'notifications.lede': 'Activity, replies and anything else that points at you.',
  'notifications.unreadCount': '{count} unread',
  'notifications.allRead': 'All read',
  'notifications.settings': 'Notification settings',
  'notifications.someone': 'Someone',
  'notifications.filterAll': 'All',
  'notifications.filterUnread': 'Unread',
  'notifications.filterPosts': 'Posts and comments',
  'notifications.filterFriends': 'Friends and requests',
  'notifications.filterGroups': 'Groups and pages',
  'notifications.filterEvents': 'Events and birthdays',
  'notifications.when.today': 'Today',
  'notifications.when.yesterday': 'Yesterday',
  'notifications.when.week': 'This week',
  'notifications.when.earlier': 'Earlier',
  'notifications.sectionCount': '{count}',
  'notifications.caughtUp': 'You are up to date',
  'notifications.caughtUpHelp': 'Anything new appears here as it happens.',
  'notifications.pendingTitle': 'Waiting for you',
  'notifications.pendingNone': 'No requests waiting.',
  'notifications.eventsTitle': 'Upcoming events',
  'notifications.eventsHelp': 'Nothing schedules one yet.',
  'notifications.liveOn': 'Connected — new notifications arrive live',
  'notifications.liveOff': 'Not connected — refresh to see what is new',
  'notifications.unread': 'Unread',
  'notifications.markAllRead': 'Mark all as read',
  'notifications.none': 'Nothing yet',
  'notifications.noneHelp': 'Requests, replies and messages will show up here.',
  'notifications.friendRequest': '{name} wants to connect',
  'notifications.friendAccepted': '{name} accepted your request',
  'notifications.newMessage': '{name} sent you a message',
  'notifications.groupPost': '{name} posted in a group',
  'notifications.groupMessage': 'New message in {name}',
  'notifications.profilePost': '{name} wrote on your profile',
  'notifications.postRepost': '{name} reposted your post',
  'notifications.storyMention': '{name} tagged you in their story',
  'settings.notifyStoryMention': 'When somebody tags me in a story',
  'notifications.aGroup': 'a group',
  'notifications.loadMore': 'Load more',

  /* Settings */
  'settings.title': 'Settings',
  'settings.breadcrumb': 'Account and privacy',
  'settings.lede': 'Your details, who can see them, how you sign in, and what TalkVibe sends you.',
  'settings.searchPlaceholder': 'Search every setting…',
  'settings.welcome': 'Welcome to TalkVibe. Add a few interests so people can find you.',
  'settings.catProfile': 'Account and profile',
  'settings.catSecurity': 'Password and security',
  'settings.catPrivacy': 'Privacy and visibility',
  'settings.catNotifications': 'Notifications',
  'settings.catBlocked': 'Blocking and muted words',
  'settings.catAudio': 'Audio and streaming',
  'settings.catLanguage': 'Language and region',
  'settings.catDevices': 'Sign-ins and devices',
  'settings.accountStatus': 'Account status and deletion',
  'settings.publicTitle': 'Public profile',
  'settings.publicLede': 'This is what appears on your profile and what anyone on TalkVibe can see.',
  'settings.viewProfile': 'View your profile',
  'settings.photos': 'Cover image and profile picture',
  'settings.photoHint': 'JPEG, PNG, WebP or GIF, up to {max} MB.',
  'settings.changeAvatar': 'Change picture',
  'settings.changeCover': 'Change cover',
  'settings.uploading': 'Uploading…',
  'settings.usernameFixed': 'Your profile lives at {url}, and the handle cannot be changed yet.',
  'settings.linkLabel': 'Label',
  'settings.addLink': 'Add a link',
  'settings.removeLink': 'Remove this link',
  'settings.interestsTitle': 'Interests and languages',
  'settings.interestsLede': 'Up to {max} interests. This is what Discover matches on, so it is worth filling in.',
  'settings.proficiency': 'How well you speak it',
  'settings.addLanguage': 'Add a language you speak',
  'settings.removeLanguage': 'Remove this language',
  'settings.contactTitle': 'Contact and account',
  'settings.contactLede': 'Private. None of this appears on your profile.',
  'settings.verified': 'Verified',
  'settings.notVerified': 'Not verified',
  'settings.emailHelp': 'Where a sign-in link and a password reset are sent.',
  'settings.sendVerification': 'Send the link',
  'settings.sending': 'Sending…',
  'settings.verificationSent': 'Sent. Check your inbox.',
  'settings.changeEmail': 'Change email',
  'settings.phone': 'Phone number',
  'settings.phoneHelp': 'For signing in and for a code by SMS.',
  'settings.birthdateHelp': 'Given when you signed up, and not editable here.',
  'settings.birthdateAudience': 'Others see the day and month, never the year.',
  'settings.securityTitle': 'Signing in safely',
  'settings.securityLede': 'What stands between your account and somebody who is not you.',
  'settings.twoFactor': 'Two-factor authentication',
  'settings.twoFactorHelp': 'A second code at sign-in, from an authenticator app.',
  'settings.passwordHelp': 'At least {min} characters. Changing it signs out every other device.',
  'settings.currentPassword': 'Current password',
  'settings.newPassword': 'New password',
  'settings.passwordChanged': 'Password changed. Every other device was signed out.',
  'settings.privacyTitle': 'Who can see you',
  'settings.privacyLede': 'Who can find your profile, message you, and see when you are around.',
  'settings.optSearchEngines': 'Let search engines show your TalkVibe profile',
  'settings.optSearchEnginesHelp': 'Whether Google and Bing may list your public profile.',
  'settings.optOnlineStatus': 'Show when you are online',
  'settings.optOnlineStatusHelp': 'The green dot on your picture, for friends and followers.',
  'settings.optWhoCanMessage': 'Who can message you directly',
  'settings.optWhoCanMessageHelp': 'Today this is settled by the connection rule: a chat needs an accepted connection.',
  'settings.optReadReceipts': 'Send read receipts in chat',
  'settings.optReadReceiptsHelp': 'Whether the other person learns you have opened their message.',
  'settings.blockedTitle': 'People you have blocked',
  'settings.blockedLede': 'They cannot message you, see your profile, or find you. They are never told.',
  'settings.blockedNone': 'You have not blocked anybody.',
  'settings.unblock': 'Unblock',
  'settings.mutedWords': 'Muted words',
  'settings.mutedWordsHelp': 'Hide posts containing words you would rather not read.',
  'settings.languageTitle': 'Language and region',
  'settings.languageLede': 'What you read in, and the clock others see beside your name.',
  'settings.timezoneNone': 'Not set',
  'settings.useDetected': 'Use {zone}, detected from this device',
  'settings.sessionsLede': 'Every device signed in to this account. Sign out any you do not recognise.',
  'settings.unsaved': 'You have changes that are not saved',
  'settings.unsavedHelp': 'Nothing is sent to TalkVibe until you save.',
  'settings.visibilityHelp.public': 'Anyone signed in to TalkVibe can see your profile.',
  'settings.visibilityHelp.friends': 'Only people you have connected with can see it.',
  'settings.visibilityHelp.private': 'Nobody but you. You will not appear in Discover.',
  'settings.proficiency.learning': 'Learning',
  'settings.proficiency.conversational': 'Conversational',
  'settings.proficiency.fluent': 'Fluent',
  'settings.proficiency.native': 'Native',
  'settings.profile': 'Profile',
  'settings.account': 'Account',
  'settings.privacy': 'Privacy',
  'settings.security': 'Security',
  'settings.sessions': 'Signed-in devices',
  'settings.save': 'Save changes',
  'settings.saving': 'Saving…',
  'settings.saved': 'Saved',
  'settings.bio': 'About you',
  'settings.visibility': 'Who can see your profile',
  'settings.visibilityPublic': 'Anyone',
  'settings.visibilityFriends': 'Connections only',
  'settings.visibilityPrivate': 'Only me',
  'settings.timezone': 'Time zone',
  'settings.spokenLanguages': 'Languages you speak',
  'settings.work': 'Work',
  'settings.education': 'Education',
  'settings.employer': 'Employer',
  'settings.jobTitle': 'Job title (optional)',
  'settings.school': 'School or university',
  'settings.fieldOfStudy': 'What you studied (optional)',
  'settings.fromYear': 'From',
  'settings.toYear': 'To',
  'settings.addEntry': 'Add',
  'settings.removeEntry': 'Remove this entry',
  'settings.socialLinks': 'Links',
  'settings.changePassword': 'Change password',
  'settings.signOutEverywhere': 'Sign out everywhere',
  'settings.revokeSession': 'Sign out',
  'settings.thisDevice': 'This device',
  'settings.lastSeen': 'Last used {when}',

  /* Reporting and moderation */
  'report.title': 'Report {name}',
  'report.whatIsWrong': 'What is wrong?',
  'report.anythingElse': 'Anything else we should know?',
  'report.optional': 'Optional',
  'report.send': 'Send report',
  'report.sending': 'Sending…',
  'report.thanks': 'Thank you — this has been sent to our moderators.',
  'report.private': 'We will not tell {name} who reported them.',
  'report.notice': 'Reports are read by our moderators. {name} is not told that you reported them, or what you said.',
  'report.reason.spam': 'Spam or unwanted advertising',
  'report.reason.harassment': 'Harassment or bullying',
  'report.reason.hate': 'Hate speech',
  'report.reason.sexual': 'Sexual or explicit content',
  'report.reason.violence': 'Violence or threats',
  'report.reason.impersonation': 'Pretending to be someone else',
  'report.reason.scam': 'Scam or fraud',
  'report.reason.other': 'Something else',
  'moderation.title': 'Moderation',
  'moderation.waiting': '{count} waiting',
  'moderation.reviewed': 'Reviewed',
  'moderation.open': 'Open',
  'moderation.actioned': 'Actioned',
  'moderation.dismissed': 'Dismissed',
  'moderation.nothing': 'Nothing here',
  'moderation.nothingOpen': 'No reports are waiting.',
  'moderation.nothingReviewed': 'Nothing has been reviewed yet.',
  'moderation.dismiss': 'Dismiss',
  'moderation.removeMessage': 'Remove message',
  'moderation.suspend': 'Suspend account',
  'moderation.notePlaceholder': 'Note for the record (optional)',
  'moderation.reportedAgo': 'Reported {when}',
  'moderation.multipleReports': '{count} people have reported them',
  'moderation.theySaid': 'They said:',
  'moderation.noEvidence': 'No content was captured.',

  /* Pages */
  'pages.title': 'Pages',
  'pages.create': 'Create a page',
  'pages.newTitle': 'Create a page',
  'pages.newLede': 'Give it a name and a category so people can find it. Everything here can be changed afterwards — except the address.',
  'pages.identity': 'What the page is',
  'pages.nameHelp': 'A business, a brand, a community — or whatever says what the page is for.',
  'pages.addressHelp': 'This is the URL. It cannot be changed afterwards.',
  'pages.categoryHelp': 'One category. It is how people browsing find you.',
  'pages.taglineHelp': 'One line, shown under the name.',
  'pages.descriptionHelp': 'The longer version, on the About panel.',
  'pages.images': 'Pictures',
  'pages.avatar': 'Page picture',
  'pages.coverImage': 'Cover photo',
  'pages.changeImage': 'Change',
  'pages.removeImage': 'Remove image',
  'pages.imageFailed': 'The page was created, but {what} could not be uploaded. Try again from Manage page.',
  'pages.website': 'Website',
  'pages.websitePlaceholder': 'example.com',
  'pages.websiteHelp': 'We add https:// if you leave it out.',
  'pages.contactEmail': 'Contact email',
  'pages.contactEmailHelp': 'Shown on the page. This is not your sign-in address.',
  'pages.contactPhone': 'Contact phone',
  'pages.avatarLabel': 'Page picture',
  'pages.avatarHint': 'Square, around 320 × 320',
  'pages.coverLabel': 'Cover photo',
  'pages.coverHint': 'Wide, around 1200 × 450',
  'pages.addImage': 'Add',
  'pages.contact': 'Contact details and website',
  'pages.optional': 'optional',
  'pages.termsNotice': 'Creating a page means you accept the {terms}.',
  'pages.creating': 'Creating…',
  'pages.tipsTitle': 'Naming it well',
  'pages.tipsBody': 'Skip "official page" and ALL CAPS. A good name says straight away what somebody gets by following it.',
  'pages.preview': 'Live preview',
  'pages.previewNote': 'This is how the page will look to everybody else. You can change the pictures and post to it the moment it exists.',
  'pages.previewDesktop': 'Desktop',
  'pages.previewMobile': 'Phone',
  'pages.previewNameEmpty': 'Your page name',
  'pages.previewBioEmpty': 'What this page is about will appear here.',
  'pages.previewCover': 'Cover photo goes here',
  'pages.previewFollow': 'Follow',
  'pages.previewMessage': 'Message',
  'pages.previewFirstPost': 'Write your first post as {name}…',
  'pages.previewEmptyTitle': 'Ready for its first follower',
  'pages.previewEmptyBody': 'Once the page exists, the posts and photos you publish show up here.',
  'pages.steps': 'Steps',
  'pages.name': 'Page name',
  'pages.address': 'Address',
  'pages.tagline': 'One line about it',
  'pages.description': 'Description',
  'pages.category': 'Category',
  'pages.visibility': 'Visibility',
  'pages.noCategory': 'No category',

  'pageManage.title': 'Manage page',
  'pageManage.edit': 'Edit',
  'pageManage.insights': 'Insights',
  'pageManage.ads': 'Advertising',
  'pageManage.save': 'Save changes',
  'pageManage.saved': 'Saved',
  'pageManage.noChanges': 'Nothing to save yet',
  'pageManage.notYours': 'This page is not yours to manage.',
  'pageManage.viewInstead': 'View the page instead',
  'pageManage.imagesSoon': 'A picture and a banner cannot be uploaded for a page yet.',
  'pageManage.followers': 'Followers',
  'pageManage.posts': 'Posts',
  'pageManage.likes': 'Likes',
  'pageManage.comments': 'Comments',
  'pageManage.recentPosts': 'Posts in 30 days',
  'pageManage.perPost': 'Reactions per post',
  'pageManage.noViews':
    'There are no view or reach numbers here, and no week-on-week change. Nothing in '
    + 'TalkVibe records a view, and no daily snapshot of your follower count is kept — so '
    + 'those are figures we cannot produce rather than ones we left out. An estimate in '
    + 'their place would be worse than a blank.',
  'pageManage.topPosts': 'Most reacted to',
  'pageManage.noTopPosts': 'No post has a like or a comment yet.',
  'pageManage.noWords': 'A post with no words',
  'pages.public': 'Public',
  'pages.unlisted': 'Unlisted — reachable by link only',
  'pages.follow': 'Follow',
  'pages.unfollow': 'Following',
  'pages.followers.one': '{count} follower',
  'pages.followers.other': '{count} followers',
  'pages.posts.one': '{count} post',
  'pages.posts.other': '{count} posts',
  'pages.writePost': 'Write a post',
  'pages.publish': 'Publish',
  'pages.noPosts': 'Nothing posted yet',
  'pages.mine': 'Your pages',
  'pages.notFound': 'Page not found',
  'pages.about': 'About',
  'pages.aboutEmpty': 'This page has not written anything about itself yet.',
  'pages.owner': 'Managed by',
  'pages.founded': 'Founded {when}',
  'pages.shareLink': 'Copy link',
  'pages.linkCopied': 'Link copied',
  'pages.category.community': 'Community',
  'pages.category.language-exchange': 'Language exchange',
  'pages.category.travel': 'Travel',
  'pages.category.food': 'Food',
  'pages.category.music': 'Music',
  'pages.category.gaming': 'Gaming',
  'pages.category.study': 'Study',
  'pages.category.business': 'Business',
  'pages.category.art': 'Art',
  'pages.category.sport': 'Sport',
  'pages.category.technology': 'Technology',
  'pages.category.other': 'Other',

  'register.title': 'Create a new account',
  'register.usernamePlaceholder': 'username',
  'register.emailPlaceholder': 'Email address',
  'register.passwordPlaceholder': 'New password',
  'register.chooseCountry': 'Choose a country',
  'register.chooseLanguage': 'Choose a language',
  'register.lede': 'Free, and it takes about a minute.',
  'verify.title': 'Confirm your email address',
  'verify.lede': 'One tap finishes it. We ask rather than doing it automatically, because mail scanners open links before you do.',
  'verify.action': 'Confirm my address',
  'verify.createdTitle': 'Your account is ready',
  'verify.createdLede': 'Sign in with the password you chose and TalkVibe is yours.',
  'verify.doneTitle': 'Email confirmed',
  'verify.doneLede': 'Thanks — your address is verified.',
  'verify.goToApp': 'Go to TalkVibe',
  'verify.failedTitle': 'That link did not work',
  'verify.failed': 'That link could not be confirmed.',
  'verify.missingToken': 'This link is missing its token.',
  'verify.failedHelp': 'Links work for 24 hours and can only be used once.',
  'verify.startAgain': 'Start again',
  'register.checkInbox': 'Check your inbox',
  'register.sentTo': 'We sent a confirmation link to {email}. Open it to finish creating your account.',
  'register.linkExpires': 'The link works for 24 hours. Nothing is created until you open it.',
  'register.sendAgain': 'Send the link again',
  'register.badge': 'Just one step',
  'register.usernameHelp': '{min}–{max} characters: lowercase letters, numbers and underscores.',
  'register.usernameFormatOk': 'Valid format. We check it is free when you submit.',
  'register.emailHelp': 'We send a link here to confirm the address is yours.',
  'register.birthdate': 'Date of birth',
  'register.birthdateHelp':
    'You need to be {min} or older. Other people see the day and month, never the year.',
  'register.displayNameOptional': 'optional',
  'register.displayNamePlaceholder': 'The name people see',
  'register.displayNameHelp': 'Left blank, your username is used.',
  'register.confirmPassword': 'Confirm password',
  'register.confirmPasswordPlaceholder': 'Type the password again',
  'register.passwordMismatch': 'The two passwords do not match.',
  'register.rules.title': 'Your password needs to be',
  'register.rules.met': '{done} of {total}',
  'register.rules.length': 'At least {count} characters',
  'register.rules.varied': 'Not the same character over and over',
  'register.rules.uncommon': 'Not a commonly guessed password',
  'register.whereTitle': 'Where you are, and what you read',
  'register.termsAgree': 'I agree to the {terms} and the {privacy}.',
  'register.termsRequired': 'Please accept the terms to continue.',
  'register.submit': 'Create account',
  'register.failed': 'Could not create your account. Please try again.',
  'recover.title': 'Forgot your password?',
  'recover.lede': 'Enter the email or username on your account, and we will send a link to set a new password.',
  'recover.badge': 'Account recovery',
  'recover.identifier': 'Email or username on the account',
  'recover.identifierHint': 'e.g. name@example.com or @username',
  'recover.submit': 'Send reset link',
  'recover.sending': 'Sending…',
  'recover.expiryTitle': 'The link is short-lived',
  'recover.expiryBody': 'It works for {count} minutes and once only. Do not forward it to anybody — whoever opens it can set the password.',
  'recover.failed': 'Could not send the email. Please try again.',
  'recover.stepsTitle': 'Three steps',
  'recover.step1': 'Tell us who you are',
  'recover.step1Body': 'Email or username',
  'recover.step2': 'Open your inbox',
  'recover.step2Body': 'Follow the link within {count} minutes',
  'recover.step3': 'Choose a new password',
  'recover.step3Body': 'Then sign in with it',
  'recover.sentTitle': 'Check your inbox',
  'recover.sentBody': 'If an account exists for {identifier}, a link is on its way. It expires in {count} minutes.',
  'recover.sentSpam': 'Nothing after a minute or two? Look in your spam folder.',
  'recover.sentAgain': 'Try a different address',

  'reset.title': 'Choose a new password',
  'reset.lede': 'Pick something you can remember. You will sign in with it straight after.',
  'reset.submit': 'Set new password',
  'reset.saving': 'Saving…',
  'reset.signsOut': 'This signs you out everywhere, on every device.',
  'reset.noToken': 'This link is missing its token.',
  'reset.noTokenAction': 'Request a new link',
  'reset.failed': 'Could not reset your password.',

  'geo.suggestLabel': 'Language suggestion',
  'geo.suggestTitle': 'It looks like you are in {country}.',
  'geo.suggestBody': 'Would you rather read TalkVibe in {language}?',
  'geo.suggestAccept': 'Switch to {language}',
  'geo.suggestDismiss': 'No thanks',

  'register.sideTitle': 'One account, every language',
  'register.sideLede': 'Choose the language you read in. Everything that reaches you arrives in it.',
  'home.popularInterests': 'Popular interests',
  'home.peopleToMeet': 'People you may want to meet',
  'home.noSuggestions': 'Nobody to suggest just yet',

  'post.like': 'Like',
  'post.liked': 'Liked',
  'post.likes.one': '{count} like',
  'post.likes.other': '{count} likes',
  'post.comment': 'Comment',
  'post.comments.one': '{count} comment',
  'post.comments.other': '{count} comments',
  'post.share': 'Share',
  'post.shareCopied': 'Link copied',
  'post.writeComment': 'Write a comment',
  'post.postComment': 'Post',
  'post.noComments': 'No comments yet',
  'post.deletePost': 'Delete post',
  'post.deleteComment': 'Delete',
  'post.deleteConfirm': 'Delete this?',
  'post.removed': 'This was removed',
  'post.signInToComment': 'Sign in to comment',
  'post.loadMoreComments': 'More comments',

  /* Landing page (signed out) */
  'landing.nav.label': 'Product',
  'landing.nav.features': 'Features',
  'landing.nav.how': 'How it works',
  'landing.nav.interests': 'Interests',
  'landing.footer.label': 'Footer',
  'landing.footer.rights': 'All rights reserved.',

  'landing.hero.badge': 'Chat across languages',
  'landing.hero.title': 'Talk to the world without leaving your own language',
  'landing.hero.subtitle':
    'Everyone writes in the language they think in. Each person reads it in theirs, and the original is always one tap away.',
  'landing.hero.cta': 'Get started — free',
  'landing.hero.secondary': 'I already have an account',

  'landing.stats.languages': '{count} languages',
  'landing.stats.countries': '{count} countries',
  'landing.stats.interests': '{count} interests to follow',

  'landing.preview.label': 'One conversation, two languages',
  'landing.preview.writes': '{name} in {place} writes',
  'landing.preview.reads': '{name} in {place} reads',
  'landing.preview.shownIn': 'Shown in {language}',
  'landing.preview.original': 'Original always kept',

  'landing.features.eyebrow': 'Why TalkVibe',
  'landing.features.title': 'Built for talking to people you do not share a language with',
  'landing.features.lede':
    'Translation is not a feature bolted onto a chat app here. It is the reason the app exists, and everything else is built around it.',
  'landing.features.translate.title': 'Translated as it arrives',
  'landing.features.translate.body':
    'Messages, posts and comments are translated into the language you read in. The original stays visible underneath — a translation you cannot check is not one you can trust.',
  'landing.features.discover.title': 'Find people, not an algorithm',
  'landing.features.discover.body':
    'Search by country, language or interest. The ranking is explicit and documented, with no popularity signal deciding who you are allowed to meet.',
  'landing.features.spaces.title': 'Pages, groups and stories',
  'landing.features.spaces.body':
    'Post to your own timeline, run a public page, or keep it to a group. Stories last a day. All of it translated the same way.',
  'landing.features.privacy.title': 'Privacy you can actually set',
  'landing.features.privacy.body':
    'Choose who sees your profile, block and report, export everything we hold about you, and delete your account for real.',

  'landing.how.eyebrow': 'How it works',
  'landing.how.title': 'Three steps, then you are talking',
  'landing.how.step1.title': 'Pick the language you read in',
  'landing.how.step1.body': 'Everything that reaches you arrives in it, whatever language it was written in.',
  'landing.how.step2.title': 'Find someone',
  'landing.how.step2.body': 'By country, by language they speak, or by something you are both into.',
  'landing.how.step3.title': 'Just write',
  'landing.how.step3.body': 'In your own language. They read it in theirs. Neither of you switches.',

  'landing.interests.eyebrow': 'Find your people',
  'landing.interests.title': 'Start from something you are into',
  'landing.interests.lede': 'Every interest is a way into the people who share it.',
  'landing.interests.all': 'See everything',

  'landing.cta.badge': 'Free, with nothing hidden behind a price',
  'landing.cta.title': 'Ready to meet someone who does not speak your language?',
  'landing.cta.body': 'Creating an account takes under a minute.',
  'landing.cta.primary': 'Create your account',
  'landing.cta.secondary': 'Sign in instead',

  'legal.terms': 'Terms of Use',
  'download.footerLink': 'Desktop app',
  'download.title': 'TalkVibe on your desktop',
  'download.intro': 'Free, and the same account you use on the web.',
  'download.why': 'The window can be closed and the app keeps its connection open, so a message that arrives while you are not looking still reaches you — including in group chats, which the website cannot notify you about at all unless the tab is open.',
  'download.notPublished': 'The installers are built and tested but are not on a download server yet, so the buttons below are not live. Nothing here will work until they are uploaded.',
  'download.yourComputer': 'your computer',
  'download.version': 'Version {version}',
  'download.noMobile': 'For a phone, use the website — the mobile apps are not released yet.',
  'download.warnMac': 'macOS will refuse to open this the first time, because the app is not signed by an Apple certificate yet. Right-click the app in Applications, choose Open, then Open again in the dialog. You only have to do it once.',
  'download.warnWindows': 'Windows will show a blue “Windows protected your PC” box, because the installer is not signed by a certificate yet. Click More info, then Run anyway.',
  'download.warnLinux': 'An AppImage needs no install: make it executable with chmod +x and run it. The .deb installs with apt install ./TalkVibe-*.deb and puts the app in your launcher.',
  'legal.privacy': 'Privacy Policy',
  'settings.dangerZone': 'Deleting your account',
  'settings.exportData': 'Download your data',
  'settings.exportHelp': 'Everything we hold about you, as a JSON file.',
  'settings.deleteAccount': 'Delete account',
  'settings.deleteHelp': 'This removes your profile, connections and any pages you own. It cannot be undone.',
  'settings.deleteConfirm': 'Type your password to confirm',
  'settings.notifications': 'Notifications',
  'settings.notifyFriendRequest': 'Connection requests',
  'settings.notifyFriendAccepted': 'Accepted requests',
  'settings.notifyNewMessage': 'New messages',
  'settings.notifyGroupPost': 'Posts in your groups',
  'settings.notifyPostMention': 'Somebody tags me in a post',
  'settings.notifyProfilePost': 'Somebody writes on my profile',
  'settings.notifyPostRepost': 'Somebody reposts my post',

  'settings.browserNotifications': 'Notify me on this device',
  'settings.browserNotificationsHelpPush':
    'Your browser notifies you even when TalkVibe is closed. This is a setting for this '
    + 'browser only, not for your account.',
  'settings.browserNotificationsHelp':
    'Your browser shows a notification while TalkVibe is open in a tab. This is a '
    + 'setting for this browser only, not for your account.',
  'settings.browserNotificationsBlocked':
    'Your browser is blocking notifications for this site. Allow them in its site '
    + 'settings — we cannot ask again from here.',
  'settings.browserNotificationsUnsupported':
    'This browser cannot show them. On iPhone and iPad, add TalkVibe to your Home '
    + 'Screen first.',
  'settings.browserNotificationsDismissed': 'Nothing was chosen. Turn it on to be asked again.',
  'settings.browserNotificationsTest': 'Send a test',
  'settings.browserNotificationsTestBody': 'Notifications are working.',

  'feed.title': 'Your feed',
  'feed.empty': 'Nothing here yet',
  'feed.emptyHelp': 'Write something above, follow a page, or join a group.',
  'feed.inGroup': 'in {name}',
  'post.reply': 'Reply',
  'post.replyTo': 'Reply to {name}',
  'post.replies.one': '{count} reply',
  'post.replies.other': '{count} replies',

  'composer.placeholder': 'What would you like to share?',
  'nav.seeAllRequests': 'See all requests',
  'stories.title': 'Stories',
  'stories.add': 'Add story',
  'stories.yours': 'Your story',
  'stories.pickPhoto': 'Choose a photo',
  'stories.uploading': 'Uploading…',
  'stories.caption': 'Caption',
  'stories.share': 'Share',
  'stories.expiryNote': 'Stories disappear after 24 hours.',
  'stories.subtitle': 'Share a moment, a photo or a thought with your friends.',
  'stories.ttlBadge': '{count} h',
  'stories.chooseType': 'Choose the kind of story',
  'stories.typeMedia': 'Photo story',
  'stories.typeMediaBody': 'Upload a picture and add a caption to it.',
  'stories.typeText': 'Text story',
  'stories.typeTextBody': 'Type a message over a colourful background.',
  'stories.dropzone': 'Drag a photo here',
  'stories.dropzoneOr': 'or click to choose one from your device',
  'stories.maxSize': 'Up to {count} MB',
  'stories.changePhoto': 'Choose another photo',
  'stories.yourCaption': 'Your caption',
  'stories.captionPlaceholder': 'Say something about it…',
  'stories.charCount': '{used} / {max} characters',
  'stories.fontStyle': 'Font style',
  'stories.textAlign': 'Text alignment',
  'stories.background': 'Background',
  'stories.stickers': 'Interactive stickers',
  'stories.stickerMusic': 'Add music',
  'stories.stickerLocation': 'Location',
  'stories.stickerMention': 'Tag a friend',
  'stories.stickerPoll': 'Poll',
  'stories.privacy': 'Who can see it',
  'stories.privacyPublic': 'Everyone',
  'stories.privacyNote': 'Stories are shown to everyone who can see your profile.',
  'stories.settings': 'Story settings',
  'stories.saveDraft': 'Save draft',
  'stories.close': 'Close',
  'stories.livePreview': 'Live preview (9:16)',
  'stories.replyPlaceholder': 'Send a reply…',
  'stories.justNow': 'just now',
  'stories.previewEmpty': 'Your photo appears here',
  'stories.background.dusk': 'Dusk',
  'stories.background.ocean': 'Ocean',
  'stories.background.citrus': 'Citrus',
  'stories.background.forest': 'Forest',
  'stories.background.rose': 'Rose',
  'stories.background.ink': 'Ink',
  'stories.textStyle.plain': 'Plain',
  'stories.textStyle.bold': 'Bold',
  'stories.textStyle.light': 'Light',
  'stories.fontStyleHint': 'Weight and spacing. The typeface is always your own system font, so every script renders properly.',
  'stories.textAlign.left': 'Left',
  'stories.textAlign.center': 'Centre',
  'stories.textAlign.right': 'Right',
  'stories.audience.profile': 'As my profile',
  'stories.audience.friends': 'Friends only',
  'stories.audience.me': 'Only me',
  'stories.stickerMusicWhy': 'There is no audio anywhere in TalkVibe yet, and a music library needs licensing before it needs code.',
  'stories.placeLabel': 'Where are you?',
  'stories.placePlaceholder': 'Near BTS Asok',
  'stories.placeHint': 'Write it however you would tell a friend. There is no map behind this, so a district or a station is more use than an address.',
  'stories.mentionPlaceholder': 'Search your friends…',
  'stories.mentionEmpty': 'Nobody left to tag. You can only tag friends.',
  'stories.untag': 'Remove {name}',
  'stories.pollQuestion': 'Poll question',
  'stories.pollQuestionPlaceholder': 'Where should we go?',
  'stories.pollOptionPlaceholder': 'Option {n}',
  'stories.pollAddOption': 'Add another option',
  'stories.pollRemoveOption': 'Remove this option',
  'stories.pollIncomplete': 'A poll needs a question and at least two different options.',
  'stories.draftFound': 'You have an unfinished story.',
  'stories.draftRestore': 'Pick it up',
  'stories.draftDiscard': 'Throw it away',
  'stories.draftNoPhoto': 'Your words are back. The photo was not saved — choose it again.',
  'stories.previewTextEmpty': 'Your words appear here',
  'stories.remove': 'Delete story',
  'stories.removeConfirm': 'Delete this story?',
  'stories.views': 'Views',
  'stories.next': 'Next story',
  'stories.previous': 'Previous story',
  'stories.loadFailed': 'Stories did not load',
  'profile.posts': 'Posts',
  'profile.noPosts': 'Nothing here yet. What you post to your timeline appears here.',
  'profile.writeOnWall': 'Write on this profile',
  'profile.writeOnWallPlaceholder': 'Write something to {name}…',
  'profile.writeOnWallHelp': 'Friends can see this on their profile. They can remove it.',
  'pages.slugHelp': 'Your page lives at talkvibe.me/p/…',
  'pages.slugTaken': 'That address is taken',
  'pages.created': 'Page created',
  'pages.yours': 'Your pages',
  'pages.none': 'You have no pages yet',
  'pages.openFeed': 'Posts',

  /* Common */
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.confirm': 'Confirm',
  'common.loading': 'Loading…',
  'common.error': 'Something went wrong',
  'common.tryAgain': 'Try again',
  'common.search': 'Search',
  'common.required': 'Required',
  'common.optional': 'Optional',
  'common.justNow': 'just now',
} as const;
